export const SORTERA = 'sortera';
export const SORTERA_GOTEBORG = 'sorteragoteborg';
export const SORTERA_STOCKHOLM = 'sorterastockholm';
export const BIG_BAG = 'bigbag';
export const SORTERA_MALMO = 'sorteramalmo';
export const AKERISACKEN = 'akerisacken';
export const SORTERA_OREBRO = 'sorteraorebro';
export const COMPANY_CODES = [
    SORTERA_GOTEBORG,
    SORTERA_STOCKHOLM,
    BIG_BAG,
    SORTERA_MALMO,
    AKERISACKEN,
    SORTERA_OREBRO,
];
export const COMPANY_LABEL_BY_CODE = {
    [SORTERA_STOCKHOLM]: 'Sortera Stockholm',
    [SORTERA_GOTEBORG]: 'Sortera Göteborg',
    [SORTERA_MALMO]: 'Sortera Malmö',
    [SORTERA_OREBRO]: 'Sortera Örebro',
    [AKERISACKEN]: 'Åkerisäcken',
    [BIG_BAG]: 'BigBag',
};
